<template>
  <zen-one 
  :showuserinfo="false" 
  title=""
  :crumbs="crumbs"
  >
  <z-page
  title="SENARAI PENYELENGGARAAN BAKA"
  >

  <w-dialog
    ref="draggableDialog"
    v-model="dialog.show"
    :fullscreen="dialog.fullscreen"
    :width="dialog.width"
    :persistent="dialog.persistent"
    :persistent-no-animation="dialog.persistentNoAnimation"
    title-class="primary-dark1--bg white">
    <template #title>
           <div
             class="dialog-title-dragger"
             @mousedown="initDrag"
             style="cursor: move; display: flex; align-items: center;"
           >
             <w-icon class="mr2">fal fa-cog</w-icon>
             {{ dialog.title }}
           </div>
         </template>

    <w-form 
      ref="form" 
      v-model="dialog.valid"
    >
    <z-select class="mt4" :items="ternak" label="Jenis Ternakan"  v-model="form.lkp_ternakan_id" @input="getRas()" :validators="[validators.required]"></z-select>
    <z-select class="mt4" :items="ras" label="Spesies Baka"  @input="getJurusan()" v-model="form.lkp_ras_id" :validators="[validators.required]"></z-select>
    <z-select class="mt4" :items="jurusan" label="Jurusan Baka"  v-model="form.lkp_jurusan_id" :validators="[validators.required]"></z-select>
    <z-input label="Kod Baka" v-model="form.kode" name="Kod" :validators="[validators.required]" />
    <z-input label="Baka" v-model="form.nama" name="Nama" :validators="[validators.required]"  />
    <w-textarea class="mt4" style="white-space: pre-line" no-autogrow resizable rows="6" label="Kriteria Baka" v-model="form.keterangan" name="Keterangan" :validators="[validators.required]" />
    <z-input label="Susunan" v-model="form.seq" name="Seq" :validators="[validators.required]" />
    <br>
    <w-switch class="mt4" width="col-12" v-model="form.status" label="Status" />
    </w-form>
        

    
    <template #actions>
      <div class="spacer" />
      <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 10px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="dialog.show = false">TUTUP</w-button>
      <w-button 
      class="ml1" 
      :loading="dialog.loading"
      @click="validateAndSubmit"
      >
        SIMPAN
      </w-button>
    </template>

    
  </w-dialog>
  

  <z-table
    ref="tbluser"
    title="SENARAI PENYELENGGARAAN BAKA"
    :headers="table.headers"  
    :items="table.items"
    :meta="table.meta"
    class=""
  >


 
  <template #button>
        <w-button dark class="green--bg ml1" @click="add()">
            <w-icon class="mr1">fal fa-plus</w-icon> TAMBAH
        </w-button>
    </template>
   
  
    <template #header-label="{ header, label, index }">
      <template v-if="header.key == 'action'">
      <!-- <w-icon xs>fal fa-pencil</w-icon> -->
      Tindakan
      </template>
      <template v-else>
      {{ label }}
      </template>
    
    </template>

    <template #item-cell.action="{ item, label, header, index }">
      <w-flex class="flex justify-center">
        <w-button class="fs-2 pr3 bs" bg-color="orange-light3" tile @click="edit(item)">
          <w-icon xs class="mr2">fal fa-pencil</w-icon> KEMASKINI

        </w-button>
        &nbsp;  
         <w-button class="fs-2" v-if="(item.padam == 1  ) && $zutil.anyRole(['1', '3'])" bg-color="red-light1" dark tile @click="destroy1(item.id)">
       <w-icon xs class="mr2">fal fa-trash</w-icon> Padam </w-button>
       &nbsp;
       
        
      </w-flex>
    </template>

  </z-table>

  </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'

export default {
  extends: ZResource,
  props: {
    items: [Array, Object],
  },
  data() {
    return {
      resourceurl: 'penyelenggaraan.baka',
      crumbs: [
        { label: this.$page.props.app_name, route: '/' },
        { label: 'Penyelenggaraan', route: '/penyelenggaraan' },
        { label: 'Baka', route: '/penyelenggaraan/baka' }
      ],
      
      form: {
        id: 0,
        nama: '',
        kode: '',
        lkp_ternakan_id: '',
        lkp_ras_id: '',
        lkp_jurusan_id: '',
        seq:'',
        status:'',
      },
      ternak: [], 
      ras: [],    // Initialize as empty array
      jurusan: [], // Initialize as empty array
    }
  },
  methods: {
      add(){
          this.form = {
              id : 0,
              status : 1,
          }
          
          this.dialog.show = true
          this.dialog.title = 'TAMBAH'
          this.form.saveButton = "Save"
          // Call the lookup functions when adding a new item
          this.getTernak()
          this.getRas()
          this.getJurusan()
      },
      edit(form){
          this.form = form
          this.dialog.show = true
          this.dialog.title = 'KEMASKINI'
          this.form.saveButton = "Save"
          // Call the lookup functions when editing
          this.getTernak()
          this.getRas()
          this.getJurusan()
      },

      getTernak(){
        this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
          this.ternak = res || [] 
        }).catch(() => {
          this.ternak = [] 
        })
      },


         getRas(){
        this.$zcomm.get(this.api_service + 'lookup/ras/'+this.form.lkp_ternakan_id, {}).then(res => {
          this.ras = res || []
        }).catch(() => {
          this.ras = []
        })
      },

      getJurusan(){
        this.$zcomm.get(this.api_service + 'lookup/jurusan/'+this.form.lkp_ternakan_id, {}).then(res => {
          this.jurusan = res || []
        }).catch(() => {
          this.jurusan = []
        })
      },

      async validateAndSubmit() {
      const valid = await this.$refs.form.validate()
      if (!valid) {
        this.$zutil.notify("Pastikan data sudah terisi", false);
        return
      }
      this.submit()
    },
      
      initDrag(e) {
     const dialog = this.$refs.draggableDialog?.$el
     const content = dialog?.querySelector('.w-dialog__content')
     if (!content) return

     content.style.position = 'fixed'
     content.style.margin = 0
     content.style.width = dialog.style.width || '500px'
     content.style.zIndex = 1050

     const startX = e.clientX
     const startY = e.clientY
     const rect = content.getBoundingClientRect()
     const origLeft = rect.left
     const origTop = rect.top

     const onMouseMove = (event) => {
       const dx = event.clientX - startX
       const dy = event.clientY - startY
       content.style.left = `${origLeft + dx}px`
       content.style.top = `${origTop + dy}px`
     }

     const onMouseUp = () => {
       document.removeEventListener('mousemove', onMouseMove)
       document.removeEventListener('mouseup', onMouseUp)
     }

     document.addEventListener('mousemove', onMouseMove)
     document.addEventListener('mouseup', onMouseUp)
   },


      destroy1(id) {
        this.$swal({
          title: 'Anda Pasti?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
          if (result.value) {
            this.$zcomm.delete(this.resourceurl + '.destroy', id)
            .then(res => {
              this.sending = false;
              this.$inertia.visit(this.$page.url)
              this.removeitem(res)
              if (typeof this.onAfterDelete === "function") {
                this.onAfterDelete()
              }
            })
          }
        })
      }
  },

  mounted() {
    this.getTernak()
    this.getRas()
    this.getJurusan()
    // override default setting
    this.dialog.width = 500
  },
}
</script>

<style scoped>
.table tbody tr td {
  white-space: pre-wrap
}

.w-dialog {
  position: fixed !important;
}
.draggable-dialog {
  position: fixed !important;
  margin: 0 !important;
  width: 500px !important;
  z-index: 1050;
}

</style>

